export const DateTimeOptionsFullShort = { dateStyle: 'full', timeStyle: 'short' }
export const DateTimeOptionsLongShort = { dateStyle: 'long', timeStyle: 'short' }
export const DateTimeOptionsMediumShort = { dateStyle: 'medium', timeStyle: 'short' }
export const DateTimeOptionsShortShort = { dateStyle: 'short', timeStyle: 'short' }

export const DateTimeOptionsFullMedium = { dateStyle: 'full', timeStyle: 'medium' }
export const DateTimeOptionsLongMedium = { dateStyle: 'long', timeStyle: 'medium' }
export const DateTimeOptionsMediumMedium = { dateStyle: 'medium', timeStyle: 'medium' }
export const DateTimeOptionsShortMedium = { dateStyle: 'short', timeStyle: 'medium' }

export const DateTimeOptionsFullLong = { dateStyle: 'full', timeStyle: 'long' }
export const DateTimeOptionsLongLong = { dateStyle: 'long', timeStyle: 'long' }
export const DateTimeOptionsMediumLong = { dateStyle: 'medium', timeStyle: 'long' }
export const DateTimeOptionsShortLong = { dateStyle: 'short', timeStyle: 'long' }

export const DateTimeOptionsFullFull = { dateStyle: 'full', timeStyle: 'full' }
export const DateTimeOptionsLongFull = { dateStyle: 'long', timeStyle: 'full' }
export const DateTimeOptionsMediumFull = { dateStyle: 'medium', timeStyle: 'full' }
export const DateTimeOptionsShortFull = { dateStyle: 'short', timeStyle: 'full' }
